import { render, staticRenderFns } from "./WeChatAppletDownload.vue?vue&type=template&id=579b416f&scoped=true"
import script from "./WeChatAppletDownload.vue?vue&type=script&lang=js"
export * from "./WeChatAppletDownload.vue?vue&type=script&lang=js"
import style0 from "./WeChatAppletDownload.vue?vue&type=style&index=0&id=579b416f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b416f",
  null
  
)

export default component.exports